import React from 'react';
import ReactDOM from 'react-dom/client';
import '@axi/tokens/css';
import App from './app/App';
import { installGlobalErrorHandlers } from './shared/telemetry/clientLog';
import { _installTelemetry } from './shared/api/client';
import './app/styles.scss';
import './app/shell.scss';
import './app/mobile-canvas.scss';
import { preloadStarSprite } from './features/letters/ui/starSprite';
import { startReleaseMonitor } from './shared/lib/releaseMonitor';

// 那些话是懒加载路由，但星星素材必须在用户点击进入前开始加载。
void preloadStarSprite().catch(() => undefined);
startReleaseMonitor();

// 启动期就把全局错误接进 telemetry；越早接住越好。
// installGlobalErrorHandlers 幂等，多次调用只有第一次生效。
installGlobalErrorHandlers();

// VITE_QA=1 时把 telemetry middleware 拼到 API 链尾部；
// 默认值 false，prod 构建不会拉起 qa/runtime 模块。
try {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const v = (import.meta as any)?.env?.VITE_QA;
  if (v === '1' || v === 1 || v === true) {
    _installTelemetry();
  }
} catch {
  /* import.meta.env 不可用时静默退化 */
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
